import React, { Component } from 'react';
import Apng from 'react-apng';
import Question from './Question';
import AXIOS from '../../api/axios';

import './style.less';
import boom from '../../static/images/homework-new/boom.png';
import firework1 from '../../static/images/homework-new/firework1.png';
import firework2 from '../../static/images/homework-new/firework2.png';
import firework3 from '../../static/images/homework-new/firework3.png';
import audio_1 from '../../static/audio/firework_1.mp3';
import audio_2 from '../../static/audio/firework_2.mp3';
import audio_3 from '../../static/audio/firework_3.mp3';
import { fixZero } from '../../utils/tools';

function getIndex (cur, level0, smallIndex) {
    return Number(`${level0? '3' : '4'}${fixZero(cur + 1, 2)}0${smallIndex}`)
}
class Castle extends Component {
    constructor(props){
        super(props);
        const { device, classSchId, currentIndex, totalIndex, level0 } = props;
        this.clientWidth = document.body.clientWidth || document.documentElement.clientWidth;
        this.countInit = 1600 / this.clientWidth;
        this.questionInfo = props.questionInfo.picture? 
                props.questionInfo 
                :{
                    picture: props.questionInfo.pictureATwo,
                    text: props.questionInfo.textA,
                    audio: props.questionInfo.audioA,
                };
        this.questionInfoB = {
            picture: props.questionInfo.pictureBTwo,
            text: props.questionInfo.textB,
            audio: props.questionInfo.audioB,
        };
        this.state = {
            level0,
            classSchId,
            device,
            currentIndex,
            totalIndex,
            questionInfo: this.questionInfo,
            fireworks: [],
            fireworksStatus: false,
            level0Step: 1,
        };
        this.timeOutArr = [];
        this.firework = [];
    }
    componentWillUnmount(){
        this.timeOutArr.map(ele => (clearTimeout(ele)))
    }
    componentWillReceiveProps(nextProps){
        this.setState(nextProps)
    }
    playResult = (score) => {
        let num, audioResult, fireResult;
        if(score < 60) {
            num = [1];
            audioResult = audio_1;
            fireResult = firework1;
        }
        else if(score < 80) {
            num = [1,2];
            audioResult = audio_2;
            fireResult = firework2;
        }
        else {
            num = [1,2,3];
            audioResult = audio_3;
            fireResult = firework3;
        }
        this.setState({
            fireworks: num,
            fireResult: fireResult,
            audioResult: audioResult,
            score
        });
        this.timeOutArr.push(
            setTimeout(() => {
                this.firework.map((ele)=>{
                    if(ele){
                        ele.one();
                        this.audio1.play()
                    }
                    return false
                });
                setTimeout(() => {
                    this.setState({fireworksStatus: true})
                }, 1000);
            }, 200)
        )
    }

    restart = () =>{
        this.firework1.stop();
        this.setState({
            fireworksStatus: false,
            fireworks: [],
        });
    }

    nextQuestion = (score) => {
        const { level0Step, classSchId, device, currentIndex, level0, questionInfo } = this.state;
        let params = {
            type: 0,
            device,
            classSchId,
            index: getIndex(currentIndex, level0, level0Step),
            isRight: score > 30 ? 1 : 0,
            evaluateScore: score,
            words: questionInfo.text,
            picUrl: questionInfo.picture
        };
        // 如果有两小题
        if(this.questionInfoB.picture && level0Step === 1){
            this.setState({
                questionInfo: this.questionInfoB,
                level0Step: 2
            })
        }
        else{
            this.props.nextQuestion(score);
        }
        const paramsBp = {
            courseId: 210, // 210-NGK
            sourceType: 2, // 1-课件 2-作业
            qaType: 3, //  题目类型 1-选择题、2-判断题、3-读音题、4-多选题
            qaTemplate: '烟花读句子', // 题目模板
            qaResult: score, // 分数
            deviceName: device, // 设备
            classSchId, // 课次id
        }
        AXIOS.homeworkSave({data: params}, (res, err) => {
            if(err) console.log(err);
            else{
                console.log('作业保存进度成功');
            }
        });
        AXIOS.homeworkBp({ data: paramsBp }, (res, err) => {
            if(err) console.log(err);
            else {
                console.log('作业结果埋点成功');
            }
        });
        setTimeout(() => {
            this.child && this.child.initAudio();
        }, 500);
    }

    // 双重保存 一个月后删除
    saveAudioUrl = (url) => {
        console.log('------', url)
        const { currentIndex, level0, level0Step, device, classSchId } = this.state;
        const params = {
            index: getIndex(currentIndex, level0, level0Step),
            device,
            classSchId: Number(classSchId),
            type: 0,
            isRight: 0,
            audioUrls: [url]
        }
        AXIOS.homeworkSave({data: params}, (res, err) => {
            if(err) console.log(err);
            else{
                console.log('url保存成功');
            }
        });
    }

    render(){
        const {
            currentIndex,
            totalIndex,
            fireworks,
            fireworksStatus,
            audioResult,
            fireResult,
            questionInfo,
            level0Step,
            level0,
            device,
            classSchId
        } = this.state;
        const { completeRenderFun } = this.props;
        const parameters = {
            index: getIndex(currentIndex, level0, level0Step),
            device,
            classSchId: Number(classSchId),
            type: 0,
            isRight: 0
        }
        return(
            <div className="container homework_new castle">
                <div className="fireworks_wrap">
                {
                    fireworks.map((ele,index) => (
                        <div className={`boom_wrap`} key={index}>
                            <Apng
                                className="boom"
                                src={boom}
                                rate={0.2}
                                autoPlay={false}
                                ref={com => (this.firework[index] = com)}
                            />
                            <div className="firework" />
                        </div>
                        
                    ))
                }
                </div>
                {fireworksStatus &&
                    <Apng
                        className="firework1"
                        src={fireResult}
                        rate={1}
                        autoPlay={true}
                        ref={com => (this.firework1 = com)}
                    />
                }
                <Question
                    parameters={parameters}
                    type="castle" 
                    level0={level0}
                    defaultStep={'step0'} 
                    defaultTime={level0?6:8}
                    questionInfo={questionInfo}
                    isLast={level0? Boolean(currentIndex === totalIndex && level0Step === 2) : Boolean(currentIndex === totalIndex)}
                    nextQuestion={this.nextQuestion}
                    playResult={this.playResult}
                    restart={this.restart}
                    completeRenderFun={completeRenderFun}
                    onStorageEvaluatedAudio={this.saveAudioUrl}
                    ref={com => this.child = com} 
                />
                <audio preload='auto' ref={ com => {this.audio1 = com} } src={audioResult}></audio>
            </div>
        )
    }
}

export default Castle;



// WEBPACK FOOTER //
// ./src/template/HomeworkNew/Castle.jsx